// src/pages/AuthPage.js
import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import "./AuthPage.css";

export default function AuthPage() {
  const { loginGoogle, loginEmail, registerEmail } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/profile";

  const [mode, setMode]         = useState("login"); // login | register
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [name, setName]         = useState("");
  const [error, setError]       = useState(null);
  const [loading, setLoading]   = useState(false);

  const handleGoogle = async () => {
    setError(null); setLoading(true);
    try { await loginGoogle(); navigate(redirect); }
    catch (e) { setError(e.message); setLoading(false); }
  };

  const handleEmail = async (e) => {
    e.preventDefault(); setError(null); setLoading(true);
    try {
      if (mode === "login") await loginEmail(email, password);
      else await registerEmail(email, password, name);
      navigate(redirect);
    } catch (e) {
      setError(e.message.replace("Firebase: ","").replace(/\(auth\/.*\)/,"").trim());
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg" aria-hidden="true" />
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-top">
            <span className="oni-kanji">鬼</span>
            <h1 className="auth-title">{mode === "login" ? "Entrer" : "S'Invoquer"}</h1>
            <p className="auth-sub">
              {mode === "login"
                ? "Retrouve ton démon."
                : "Crée ton identité démoniaque."}
            </p>
          </div>

          {/* Google */}
          <button className="google-btn" onClick={handleGoogle} disabled={loading}>
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#EA4335" d="M5.26 9.77A7.2 7.2 0 0 1 12 4.8c1.73 0 3.29.62 4.51 1.64l3.37-3.37A12 12 0 0 0 12 0C7.37 0 3.36 2.7 1.24 6.65l4.02 3.12Z"/><path fill="#34A853" d="M16.04 18.01A7.19 7.19 0 0 1 12 19.2a7.2 7.2 0 0 1-6.72-4.57l-4.02 3.1A12 12 0 0 0 12 24c3.24 0 6.19-1.16 8.47-3.08l-4.43-2.91Z"/><path fill="#4A90D9" d="M20.47 16.92C21.13 15.5 21.5 13.8 21.5 12c0-.66-.06-1.3-.16-1.92H12v4.08h5.32a4.77 4.77 0 0 1-1.28 2.77l4.43 2.99Z"/><path fill="#FBBC05" d="M5.28 14.63A7.09 7.09 0 0 1 4.8 12c0-.9.16-1.77.44-2.57L1.22 6.31A11.93 11.93 0 0 0 0 12c0 1.93.46 3.76 1.26 5.38l4.02-2.75Z"/></svg>
            CONTINUER AVEC GOOGLE
          </button>

          <div className="auth-sep"><span>ou</span></div>

          <form onSubmit={handleEmail}>
            {mode === "register" && (
              <div className="field">
                <label>NOM DE DÉMON</label>
                <input type="text" value={name} onChange={e=>setName(e.target.value)} placeholder="Ex: L'Excuse Incarnée..." required />
              </div>
            )}
            <div className="field">
              <label>EMAIL</label>
              <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="demon@enfer.ping" required />
            </div>
            <div className="field">
              <label>MOT DE PASSE</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required minLength={6} />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button type="submit" className="btn btn-primary" style={{width:"100%", justifyContent:"center", marginTop:"0.5rem"}} disabled={loading}>
              {loading ? <><span className="spinner"/> INVOCATION...</> : mode === "login" ? "ENTRER →" : "INVOQUER MON DÉMON →"}
            </button>
          </form>

          <p className="auth-switch">
            {mode === "login"
              ? <>Pas encore de démon ? <button onClick={()=>setMode("register")}>Créer un compte</button></>
              : <>Déjà invoqué ? <button onClick={()=>setMode("login")}>Se connecter</button></>
            }
          </p>
        </div>
      </div>
    </div>
  );
}
